import React, { useState, useEffect } from "react";
import Footer from "components/Footers/Footer";
import IndexNavbar from "components/Navbars/IndexNavbar";
import blog1 from "assets/img/blog1.jpg";
import blog2 from "assets/img/blog2.png";
import blog3 from "assets/img/blog3.png";
import blog4 from "assets/img/blog4.png";
import blog5 from "assets/img/blog5.png";
import blog6 from "assets/img/blog6.jpg";
import blog7 from "assets/img/blog7.jpg";
import blog8 from "assets/img/blog8.jpg";
import blog9 from "assets/img/blog9.jpg";
import blog10 from "assets/img/blog10.jpg";
const Blog = () => {
  return (
    <section className="parkinsans">
      <IndexNavbar />
      <section className="headerbg1 xl:pb-24">
        <h1 className="xl:text-6xl lg:text-4xl md:text-3xl text-2xl font-bold text-black  text-center xl:pt-16">
          Blog
        </h1>
        <div class=" container mx-auto grid xl:grid-cols-8 lg:grid-cols-8 md:grid-cols-8 grid-cols-1 xl:px-0 px-4 gap-4 xl:mt-20">
          <div className="xl:col-span-2 lg:col-span-2 md:col-span-2">
            <div>
              <img className="xl:w-12/12" src={blog1} alt="/" />
            </div>
          </div>

          <div className="xl:col-span-6 lg:col-span-6 md:col-span-6">
            <div>
              <h1 className="xl:text-2xl text-black font-semibold textt">
                Continuous Mixing Equipment
              </h1>
              <p className="xl:text-lg lg:text-sm text-base pt-2 lg:pt-2 text-para xl:pt-2">
                Efficiency, consistency, and quality are critical for success in
                the industrial baking and food processing sectors. Batch mixing
                has long been the standard in the industry, but as production
                demands rise, businesses are searching for more reliable and
                efficient options. In this case, continuous mixing equipment is
                revolutionary for bakers, snack manufacturers, and other food
                producers.{" "}
              </p>
              <p className="xl:pt-2 xl:text-sm xl:pt-2 text-para">
                Nov 27, 2024 – Nov 29, 2024
              </p>
            </div>
          </div>
        </div>


        {/* blog2 */}
        <div class=" container mx-auto grid xl:grid-cols-8 lg:grid-cols-8 md:grid-cols-8 grid-cols-1 xl:px-0 px-4 gap-4 xl:mt-12">
          <div className="xl:col-span-2 lg:col-span-2 md:col-span-2">
            <div>
              <img className="xl:w-12/12" src={blog2} alt="/" />
            </div>
          </div>

          <div className="xl:col-span-6 lg:col-span-6 md:col-span-6">
            <div>
              <h1 className="xl:text-2xl text-black font-semibold textt">
              Screw Conveyor Types
              </h1>
              <p className="xl:text-lg lg:text-sm text-base pt-2 lg:pt-2 text-para xl:pt-2">
              Screw Conveyors Types include tubular and trough conveyors. Depending on the goods, you can select steel or stainless steel. Screw augers may be manufactured in a variety of styles and variations! The qualities of the bulk materials to be carried dictate which type of screw conveyor is required.
              </p>
              <p className="xl:pt-2 xl:text-sm xl:pt-2 text-para">
              Dec 30, 2024
              </p>
            </div>
          </div>
        </div>


         {/* blog3 */}
         <div class=" container mx-auto grid xl:grid-cols-8 lg:grid-cols-8 md:grid-cols-8 grid-cols-1 xl:px-0 px-4 gap-4 xl:mt-12">
          <div className="xl:col-span-2 lg:col-span-2 md:col-span-2">
            <div>
              <img className="xl:w-12/12" src={blog3} alt="/" />
            </div>
          </div>

          <div className="xl:col-span-6 lg:col-span-6 md:col-span-6">
            <div>
              <h1 className="xl:text-2xl text-black font-semibold textt">
              Trough Screw Conveyor
              </h1>
              <p className="xl:text-lg lg:text-sm text-base pt-2 lg:pt-2 text-para xl:pt-2">
              Kiron Food Processing Technologies manufactures Trough Screw Conveyors designed by Klinkenberg and offers a wide range of options for any bulk material handling application. All trough screw conveyors are available in abrasion-resistant steels, carbon steel, stainless steel and hot-dipped galvanized.
              </p>
              <p className="xl:pt-2 xl:text-sm xl:pt-2 text-para">
              Oct 29, 2024
              </p>
            </div>
          </div>
        </div>


        {/* blog4 */}
        <div class=" container mx-auto grid xl:grid-cols-8 lg:grid-cols-8 md:grid-cols-8 grid-cols-1 xl:px-0 px-4 gap-4 xl:mt-12">
          <div className="xl:col-span-2 lg:col-span-2 md:col-span-2">
            <div>
              <img className="xl:w-12/12" src={blog4} alt="/" />
            </div>
          </div>

          <div className="xl:col-span-6 lg:col-span-6 md:col-span-6">
            <div>
              <h1 className="xl:text-2xl text-black font-semibold textt">
              Tubular Screw Conveyor
              </h1>
              <p className="xl:text-lg lg:text-sm text-base pt-2 lg:pt-2 text-para xl:pt-2">
              Tubular screw conveyors can assume a variety of forms. They all have one thing in common: they're designed for bulk material handling. Screw shafts are used to transfer items on a variety of conveyor systems. However, there are a few frequent problems. This might include dust escapes, wear, or inappropriate applications.
              </p>
              <p className="xl:pt-2 xl:text-sm xl:pt-2 text-para">
              Oct 17, 2024
              </p>
            </div>
          </div>
        </div>



        {/* blog5 */}
        <div class=" container mx-auto grid xl:grid-cols-8 lg:grid-cols-8 md:grid-cols-8 grid-cols-1 xl:px-0 px-4 gap-4 xl:mt-12">
          <div className="xl:col-span-2 lg:col-span-2 md:col-span-2">
            <div>
              <img className="xl:w-12/12" src={blog5} alt="/" />
            </div>
          </div>

          <div className="xl:col-span-6 lg:col-span-6 md:col-span-6">
            <div>
              <h1 className="xl:text-2xl text-black font-semibold textt">
              Horizontal Screw Conveyor
              </h1>
              <p className="xl:text-lg lg:text-sm text-base pt-2 lg:pt-2 text-para xl:pt-2">
              Horizontal screw conveyors are the most common form of screw conveyor. Horizontal screw conveyors are used to transport bulk items from one stage of a process to another. They come in a variety of sizes, lengths, layouts, and construction materials.
              </p>
              <p className="xl:pt-2 xl:text-sm xl:pt-2 text-para">
              Oct 12, 2024
              </p>
            </div>
          </div>
        </div>


         {/* blog6 */}
         <div class=" container mx-auto grid xl:grid-cols-8 lg:grid-cols-8 md:grid-cols-8 grid-cols-1 xl:px-0 px-4 gap-4 xl:mt-12">
          <div className="xl:col-span-2 lg:col-span-2 md:col-span-2">
            <div>
              <img className="xl:w-12/12" src={blog6} alt="/" />
            </div>
          </div>

          <div className="xl:col-span-6 lg:col-span-6 md:col-span-6">
            <div>
              <h1 className="xl:text-2xl text-black font-semibold textt">
              Screw Conveyor
              </h1>
              <p className="xl:text-lg lg:text-sm text-base pt-2 lg:pt-2 text-para xl:pt-2">
              Screw conveyors, also known as auger conveyors, are industrial equipment used to move vast amounts of granular materials (such as powders, grains, and granules), semi-solids, liquids, and even non-flowing substances from one point to another. They improve operating efficiency by eliminating the need for human manipulation of materials. A screw conveyor's main components are a revolving screw shaft and a trough. As the screw shaft revolves, the material travels in a linear path. Screw conveyors can be set up for horizontal, vertical, or inclined transport pathways.
              </p>
              <p className="xl:pt-2 xl:text-sm xl:pt-2 text-para">
              Oct 10, 2024

              </p>
            </div>
          </div>
        </div>


        {/* blog7 */}
        <div class=" container mx-auto grid xl:grid-cols-8 lg:grid-cols-8 md:grid-cols-8 grid-cols-1 xl:px-0 px-4 gap-4 xl:mt-12">
          <div className="xl:col-span-2 lg:col-span-2 md:col-span-2">
            <div>
              <img className="xl:w-12/12" src={blog7} alt="/" />
            </div>
          </div>

          <div className="xl:col-span-6 lg:col-span-6 md:col-span-6">
            <div>
              <h1 className="xl:text-2xl text-black font-semibold textt">
              Automatic Packing Machine
              </h1>
              <p className="xl:text-lg lg:text-sm text-base pt-2 lg:pt-2 text-para xl:pt-2">
              The Automatic Packing Machine has contributed significantly to the growth of the packaging process and the development of packaging technology. Furthermore, with the development of the market and the ever-expanding distribution network, packaging has become a must for all items.
              </p>
              <p className="xl:pt-2 xl:text-sm xl:pt-2 text-para">
              Jul 24, 2024

              </p>
            </div>
          </div>
        </div>


        {/* blog8 */}
        <div class=" container mx-auto grid xl:grid-cols-8 lg:grid-cols-8 md:grid-cols-8 grid-cols-1 xl:px-0 px-4 gap-4 xl:mt-12">
          <div className="xl:col-span-2 lg:col-span-2 md:col-span-2">
            <div>
              <img className="xl:w-12/12" src={blog8} alt="/" />
            </div>
          </div>

          <div className="xl:col-span-6 lg:col-span-6 md:col-span-6">
            <div>
              <h1 className="xl:text-2xl text-black font-semibold textt">
              Rotary Drum Mixer
              </h1>
              <p className="xl:text-lg lg:text-sm text-base pt-2 lg:pt-2 text-para xl:pt-2">
              Kiron Food Processing Technologies provides Rotary drum mixers for mixing and processing fine powders, granulates, and natural products. LINDOR rotary drum mixers swiftly combine and handle huge quantities in an efficient, dependable manner that consumes little energy. We never use shear force to stress or heat particles in our rotary drum mixers. Gravity ensures that every particle maintains its original size, shape, and qualities.
              </p>
              <p className="xl:pt-2 xl:text-sm xl:pt-2 text-para">
              Jun 21, 2024

              </p>
            </div>
          </div>
        </div>


        {/* blog9 */}
        <div class=" container mx-auto grid xl:grid-cols-8 lg:grid-cols-8 md:grid-cols-8 grid-cols-1 xl:px-0 px-4 gap-4 xl:mt-12">
          <div className="xl:col-span-2 lg:col-span-2 md:col-span-2">
            <div>
              <img className="xl:w-12/12" src={blog9} alt="/" />
            </div>
          </div>

          <div className="xl:col-span-6 lg:col-span-6 md:col-span-6">
            <div>
              <h1 className="xl:text-2xl text-black font-semibold textt">
              Chips Frying Machine
              </h1>
              <p className="xl:text-lg lg:text-sm text-base pt-2 lg:pt-2 text-para xl:pt-2">
              A key player in this pursuit of perfection is technology, and when it comes to Chips Frying Machine, one brand stands out Rosenqvists. Effectiveness, reliability, and excellence are critical in the snack producing industry. Customers demand perfection from every bite, whether it's the crunchy texture of a potato chip or the filling crispness of a corn chip.
              </p>
              <p className="xl:pt-2 xl:text-sm xl:pt-2 text-para">
              Jun 21, 2024

              </p>
            </div>
          </div>
        </div>


        {/* blog10 */}
        <div class=" container mx-auto grid xl:grid-cols-8 lg:grid-cols-8 md:grid-cols-8 grid-cols-1 xl:px-0 px-4 gap-4 xl:mt-12">
          <div className="xl:col-span-2 lg:col-span-2 md:col-span-2">
            <div>
              <img className="xl:w-12/12" src={blog10} alt="/" />
            </div>
          </div>

          <div className="xl:col-span-6 lg:col-span-6 md:col-span-6">
            <div>
              <h1 className="xl:text-2xl text-black font-semibold textt">
              Multifunctional Mixers
              </h1>
              <p className="xl:text-lg lg:text-sm text-base pt-2 lg:pt-2 text-para xl:pt-2">
              Efficient mixing techniques are critical in food processing and industrial manufacturing. From blending pharmaceutical powders to homogenizing food products, mixing quality and uniformity are critical to the final result. In this situation, Lindor emerges as a leader, providing creative solutions with their Multifunctional Mixers. Supported by distributors like Kiron Food Processing Technologies in India, Lindor is reshaping the industry's standards and capabilities.
              </p>
              <p className="xl:pt-2 xl:text-sm xl:pt-2 text-para">
              Mar 30, 2024


              </p>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </section>
  );
};
export default Blog;
